import { Box, Grid, Typography, Button, TextField } from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from '@material-ui/core/styles';
import { ArrowForward } from "@material-ui/icons";
import { ReactComponent as UploadImage } from 'assets/images/icons/upload.svg';
import { ReactComponent as InfoImage } from 'assets/images/icons/info.svg';
import { ReactComponent as Preloader } from 'assets/images/icons/preloader.svg';
import BrandingButton from "components/common/BrandingButton";
import { PatientIntakeContext } from "../contexts/PatientIntakeContext";
import "./PatientIntakePage.scss";
import InsuranceUpload from "./InsuranceUpload";
import { getDocuments, fetchDocument } from "api/patientIntakeApi";

const InsurancePage = () => {

    const [t] = useTranslation();
    const intake = useContext(PatientIntakeContext);
    
    const insurance = intake.intakeInfo.insurance;
    const btnDisbaled = insurance?.FrontImage && insurance?.BackImage
    const [isUploading, setIsUploading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const useStyles = makeStyles((theme) => ({
        apptInfoStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        infoText: {
            color: "#3175F6",
            fontSize: "14px !important"
        },
        uploadButton: {
            paddingInline: "18px",
            float: "right",
            borderRadius: "8px",
            marginBlock: "15px",
            opacity: !btnDisbaled ? 0.6 : 1,
            pointerEvents: !btnDisbaled ? "none" : ""
        },
        arrowBtn: {
            paddingLeft: "5px"
        },
        boxStyle: {
            bgcolor: '#F9F9F9',
            width: '100%',
            aspectRatio: '16/5',
            borderRadius: 3,
            display: 'inline-flex',
            alignItems: "center"
        },
        grid: {
            display: "flex"
        },
        nextButton: {
            paddingInline: "18px",
            borderRadius: "8px",
            textTransform: "none !important",
            opacity: !btnDisbaled ? 0.6 : 1,
            pointerEvents: !btnDisbaled ? "none" : ""
        },
        uploadSections: {
            position: "relative"
        },
        uploadingStyle:{
            borderRadius:1,
            position : "absolute !important",
            left:"0px", right: 1, 
            top:"0px",bottom:'0px',
            backgroundColor: "#969696",
            zIndex:'999',
            bgcolor:'#969696',
            opacity:0.8,
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            gap:1
        },
        errorContainer:{
            borderRadius: "8px !important", 
            backgroundColor:"#EB5757 !important", 
            paddingInline:"10px"
        },
        errorStyle:{
            color:"#FFFFFF", 
            fontSize:"10px !important"
        }
    }));
    const classes = useStyles();

    const fetchDocuments = async () => {
            const data = await getDocuments(intake?.secureId, intake?.secureToken); 
            if(data?.patientIntakeDocuments?.length > 0){
                intake.setDocs(data?.patientIntakeDocuments);
            }      
    };

    const getDocument = async (doc, side) => {
         await fetchDocument(intake?.secureId, intake?.secureToken, doc?.documentFetchId).then((res)=>{
            if(res?.success){
                let fileType = res?.data?.filename?.split(".")?.pop();
                intake.updateInsuranceInfo({[`${side}Image`]: res?.data?.fileData, [`${side}ImageName`]: res?.data?.filename, [`${side}ImageType`]: fileType});
            }
        }).finally(()=>setLoading(false));
    };


    useEffect(() => {
        const getImageData = async () => {
            const frontImageDoc = intake?.docs?.find(doc=> doc?.documentOrientation == 'front' && doc?.documentTypeCode == "insurance")
            if(frontImageDoc){
            setLoading(true)
                await getDocument(frontImageDoc, "Front")
            
            } 

            const backImageDoc = intake?.docs?.find(doc=> doc?.documentOrientation == "back" && doc?.documentTypeCode == "insurance")
            if(backImageDoc){
            setLoading(true)
                await getDocument(backImageDoc, "Back")
            } 
        }

        getImageData();

      }, [intake?.docs]);

    useEffect(() => {
        if(intake?.secureToken) fetchDocuments();
    }, []);

    const handleClick = async () => {
        const frontImagePromise = FetchFormRecognizerAPI(insurance?.FrontImageName, insurance?.FrontImage);
        const backImagePromise = FetchFormRecognizerAPI(insurance?.BackImageName, insurance?.BackImage);
        setIsUploading(true); 
        setLoading(true);
        const imgageResponses = await Promise.all([frontImagePromise,backImagePromise]);
        imgageResponses.forEach(response => {
            var parsedData = JSON.parse(response);
            console.log("Parse", parsedData)
        })
        setIsUploading(false); 
        setLoading(false)
        intake.nextPage()
    }

    function getHeaderInfoForDocs(method = 'POST') {
        const headerInfo = {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.api+json',
        };
    
        return { method, headers: headerInfo };
    }

    const fixedHeaders = {
        'Content-Type': 'application/vnd.api+json',
         Authorization: `api-key ${process.env.REACT_APP_OCR_APIKEY}`,
        accept: '*/*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Headers': 'authorization',
        'Access-Control-Request-Method': 'POST',
      };

    const FetchFormRecognizerAPI = async (fileName, base64FileContent) => {

        var fileContent = base64FileContent.split("base64,").pop();
        const { method } = getHeaderInfoForDocs('POST');
        const payload = {
          "filename":  fileName,
          "fileContent": fileContent
        };
        const params = {
          method,
          headers: fixedHeaders,
          body: JSON.stringify(payload),
        };
        const response = await fetch(
            process.env.REACT_APP_INSURANCEOCR_URL, params
        );
        return await response.text();
       
      }

      useEffect(()=>{
        setErrorMessage(errorMessage)
      }, [errorMessage])

    return (
        <Grid container alignItems="center" justifyContent="center">
            
            <Box
                component="div"
                sx={{ flexGrow: 1, marginTop: 3 }}
            >
                <Grid container alignItems="center" justifyContent={"space-evenly"}>
                    <Grid item xs={11} marginY={1}>
                        <Typography variant="h6" component="h6" className="stepStyle">
                            {t('PatientIntake.Step')} 2/3
                        </Typography>
                    </Grid>
                    <Grid item xs={11} marginY={1}>
                        <Grid container justifyContent={"space-between"}>
                            <Grid item xs={6}>
                                <Typography variant="h5" component="h5" className="pageNameStyle">
                                    2. {t('PatientIntake.Insurance')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} className={classes.apptInfoStyle}>
                                <InfoImage /> &nbsp;
                                <Typography variant="h6" component="h6" className={classes.infoText}>
                                    {t('PatientIntake.ApptInfo')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={"center"} alignItems="center" >
                            <Grid item xs={12} >
                                <div className={classes.boxStyle} >
                                    <Grid container rowSpacing={2} justifyContent={"center"} alignItems="center" >
                                        <Grid item xs={10} md={6} className={classes.uploadSections}>
                                            {loading && 
                                                <Box component={"div"} className={classes.uploadingStyle} >
                                                        <Preloader className="rotateLoader"/>
                                                        {isUploading && <Typography sx={{color:'#fff', paddingInline:3}}>{t('PatientIntake.Uploading')}....</Typography>}
                                                </Box>
                                            }
                                            <Grid container spacing={2} justifyContent={"center"} alignItems="center" >
                                                <InsuranceUpload side="Front" setError ={setErrorMessage} />
                                                <InsuranceUpload side="Back" setError ={setErrorMessage}/>
                                            {errorMessage &&
                                                <Grid item xs={12} >
                                                    <Box component={"div"} className={classes.errorContainer}>
                                                        <Typography className={classes.errorStyle}>{errorMessage}</Typography>                                      
                                                    </Box>
                                                </Grid>
                                            }
                                            </Grid>
                                        </Grid>
                                       
                                    </Grid>
                                </div>
                                <Grid item xs={11} marginBottom={4} justifyContent={"flex-end"}>
                                    <BrandingButton
                                        type="button"
                                        className={classes.uploadButton}
                                        onClick={handleClick}
                                    >
                                        {/* {t('PatientIntake.Upload')} {<UploadImage />} */}
                                        {t('PatientIntake.Next')}<ArrowForward fontSize="small" className={classes.arrowBtn} />
                                    </BrandingButton>
                                </Grid>
                            </Grid>
                    </Grid> 
                </Grid>
            </Box>
        </Grid>
    )
}

export default InsurancePage;